import { createSlice } from '@reduxjs/toolkit';
import { fetchIssues } from './thunks/fetchIssues.js';
import { searchIssues } from './thunks/searchIssues.js';
import { searchLocations } from './thunks/searchLocations.js';

const initialState = {
  issues: [],
  filteredIssues: [],
  locations: [],
  loading: false,
  error: null,
  searchResults: []
};

const issueSlice = createSlice({
  name: 'issues',
  initialState,
  reducers: {
    clearLocations: (state) => {
      state.locations = [];
    },
    clearError: (state) => {
      state.error = null;
    },
    filterIssues: (state, action) => {
      const searchTerm = action.payload.toLowerCase();
      if (!searchTerm) {
        state.filteredIssues = state.issues;
      } else {
        // Improved search with multiple terms
        const searchTerms = searchTerm.split(' ').filter(term => term.length > 0);
        const filtered = state.issues.filter(issue => {
          const issueText = `${issue.name.toLowerCase()} ${issue.category.toLowerCase()} ${issue.description.toLowerCase()}`;
          return searchTerms.every(term => issueText.includes(term));
        });
        state.filteredIssues = Array.from(new Map(filtered.map(item => [item.id, item])).values());
      }
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch issues
      .addCase(fetchIssues.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchIssues.fulfilled, (state, action) => {
        state.loading = false;
        state.issues = Array.from(new Map(action.payload.map(item => [item.id, item])).values());
        state.filteredIssues = state.issues;
      })
      .addCase(fetchIssues.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Search issues
      .addCase(searchIssues.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchIssues.fulfilled, (state, action) => {
        state.loading = false;
        state.filteredIssues = action.payload;
      })
      .addCase(searchIssues.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.filteredIssues = [];
      })
      // Search locations
      .addCase(searchLocations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchLocations.fulfilled, (state, action) => {
        state.loading = false;
        state.locations = action.payload;
      })
      .addCase(searchLocations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearLocations, clearError, filterIssues } = issueSlice.actions;
export default issueSlice.reducer;
